module.exports = __webpack_public_path__ + "static/img/b301.0068c3c5.png";